import { render, staticRenderFns } from "./game-instructions.vue?vue&type=template&id=45b1ed7e&scoped=true&"
import script from "./game-instructions.vue?vue&type=script&lang=js&"
export * from "./game-instructions.vue?vue&type=script&lang=js&"
import style0 from "./game-instructions.vue?vue&type=style&index=0&id=45b1ed7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b1ed7e",
  null
  
)

export default component.exports